<template>
  <div>
    <div v-for="group in groupList" :key="group._id">
      <b-card no-body class="p-3 mb-2">
        <b-row class="no-gutters align-items-center">
          <b-col class="col-auto mr-3">
            <b-icon icon="people-fill" font-scale="1.4" variant="primary" />
          </b-col>
          <b-col>
            <div class="font-weight-bold">
              {{ group.name || $t("page.groups.unnamedGroup") }}
            </div>
            <small class="text-muted">
              {{ $t("page.groups.licenses") }}: {{ group.licenses }}
              &nbsp;|&nbsp;
              {{ $t("page.groups.members") }}: {{ group.members ? group.members.length : 0 }}
            </small>
          </b-col>
          <b-col class="col-auto">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="viewDetails(group._id)"
            >
              {{ $t("button.details") }}
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div v-if="isEmptyList">
      <h5 class="text-center text-muted mt-4">{{ $t("page.groups.noGroups") }}</h5>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    groupList() {
      return this.$store.getters["groups/getGroupList"];
    },
    isEmptyList() {
      return this.groupList.length === 0;
    },
  },
  methods: {
    viewDetails(groupId) {
      this.$router.push({ name: "Group-Details", params: { id: groupId } });
    },
  },
};
</script>

<style scoped></style>
